import React from 'react';

export default class ShVideoGallery extends React.Component {
  constructor(props) {
    super(props);
    this.galleryRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.videos) {
      this.galleryRef.current.videos = this.props.videos;
    }
  }

  render() {
    if (!this.props.videos) return null;
    return (
      <sh-video-gallery ref={this.galleryRef}></sh-video-gallery>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/sh-video-gallery.js